import React from 'react';
import EllipsesControl from '../../../../../EllipsesControl/EllipsesControl';
import styled from 'styled-components';

export function HeaderNameRenderer(params) {
	return (
		<StyledHeaderNameRenderer className="StyledHeaderNameRenderer">
			<EllipsesControl content={params.name} tooltip={params.name} noOfLines={1} />
			<EllipsesControl id="secondline" content={params.date} tooltip={params.date} noOfLines={1} />
		</StyledHeaderNameRenderer>
	);
}

const StyledHeaderNameRenderer = styled.section`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-16);
	color: var(--neutrals-900);
	#secondline {
		font-size: var(--px-14);
		font-weight: 400;
		margin-right: auto;
		display: flex;
		justify-content: center;
		width: 100%;
	}
`;
